"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var self = {};

self.getUserExtraData = function (user) {
  var ret = {};

  ret.isFacebookUser = !!(user && user.clientId && user.clientId.ns == 'com.facebook');
  if (ret.isFacebookUser) {
    ret.urlPicture = "https://graph.facebook.com/v2.0/" + user.clientId.id + "/picture?width=200&height=200&type=square";
  } else {
    ret.urlPicture = "https://storage.googleapis.com/openrest-static/backoffice/nophoto.png";
  }

  return ret;
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/User.js
// module id = 293
// module chunks = 0